export type ShareOutcome = "shared" | "cancelled" | "fallback";

export async function shareOrFallback({
  share,
  title,
  url,
  openFallback,
}: {
  share?: (data: ShareData) => Promise<void>;
  title: string;
  url: string;
  openFallback: () => void;
}): Promise<ShareOutcome> {
  if (!share) { openFallback(); return "fallback"; }
  try { await share({ title, url }); return "shared"; }
  catch (error) {
    if (error instanceof DOMException && error.name === "AbortError") return "cancelled";
    openFallback();
    return "fallback";
  }
}

export async function copyWithFallback({
  writeClipboard,
  legacyCopy,
}: {
  writeClipboard?: () => Promise<void>;
  legacyCopy: () => boolean;
}) {
  try {
    await writeClipboard?.();
    if (writeClipboard) return true;
  } catch { /* use the legacy path */ }
  try { return legacyCopy(); } catch { return false; }
}
